import { DATA_KEY } from './constants';
import { isLocalStorageAvailable } from '../isLocalStorageAvailable';
var FALLBACK_VALUE = {};
export function restore() {
  if (!isLocalStorageAvailable()) {
    return FALLBACK_VALUE;
  }
  var storedState;
  try {
    storedState = JSON.parse(window.localStorage.getItem(DATA_KEY) || JSON.stringify(FALLBACK_VALUE));
  } catch (e) {
    storedState = FALLBACK_VALUE;
  }
  return storedState;
}